import React, { createRef, useRef, useState, useEffect } from 'react';
import { useLoading } from '../../../../../context/LoadingContext';
import { useNavigate } from 'react-router-dom';
import api from '../../../../../apis';
import ForgetPassword from '../../../public/ForgetPassword';
import './assets/style.css';

import TopHeader from './components/topHeader';
import Footer from './components/footer';
import AdsModal from '../../../../general/modal-ads';
import Config from '../../../../../config';

import LoginCarousel from "./components/loginCarousel"

let utradeWebUrl = Config.utradeWebUrl

const topLogoNav = () => {
    return (
        <nav
            id="main-navigation-wrapper"
            className="navbar navbar-default navbar-expand-lg navbar-light"
        >
            <div className="container" style={{width:'1140px'}}>
                <div className="logo navbar-brand">
                    <a
                        // href="/Utrade"
                        className="logo-desktop"
                        onClick={()=>{
                            window.location.href = utradeWebUrl;
                        }}
                    >
                            <img
                                src="https://www.utrade.com.my/img/logo.png"
                                alt="UOB Kay Hian"
                            />
                    </a>
                    <a
                        // href="/Utrade"
                        className="logo-mobile"
                        onClick={()=>{
                            window.location.href = utradeWebUrl;
                        }}
                    >
                        <img
                            src="https://www.utrade.com.my/img/logo.png"
                            alt="Awesome Image"
                        />
                    </a>
                </div>
                <div className="navbar-header d-none">
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-toggle="collapse"
                        data-target="#main-navigation"
                        aria-controls="main-navigation"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>
                </div>
            </div>
        </nav>
    );
};

const LoginBody = () => {
    const [displayForgetPassword, setDisplayForgetPassword] = useState(false);

    const navigate = useNavigate();
    const { loading, setLoading } = useLoading();

    const [uid, setUserId] = useState('');
    const [pwd, setUserPwd] = useState('');
    const [securitycode, setSecuritycode] = useState('');
    const [errMsg, setErrMsg] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [geoLocation, setGEOLocation] = useState<{ latitude: number | null, longitude: number | null }>({ latitude: null, longitude: null });

    const userRef = useRef<HTMLInputElement>(null);
    const errRef = createRef<HTMLDivElement>();

    useEffect(() => {
        userRef.current?.focus();
    }, []);

    useEffect(() => {
        if ("geolocation" in navigator) {
      
          navigator.geolocation.getCurrentPosition(
            (position) => {
                setGEOLocation({
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude,
                });
            },
            (err) => {
              console.log(err.message);
            }
          );
        } else {
            alert("Geolocation is not supported by your browser.");
        }
    }, []);

    useEffect(() => {
        setErrMsg('');
    }, [uid, pwd, securitycode]);

    const handleLogin = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        await setLoading(true);

        let result = await api.userLoginMFA({
            username: uid,
            password: pwd,
            secret_code: securitycode,
            geolocation: geoLocation || null
        });

        if (result != false && result.status == 0) {
            window.location.href = "/";
            // window.location.reload();
            // navigate('/');
        } else {
            setLoading(false);
        }
    };

    const togglePassword = () => {
        setShowPassword(prev => !prev);
    };
  
    return (
        <>
            <section className="contact_us-second">
                <div className="row">
                    <div className="col-lg-6 d-none d-lg-block">
                        <div className="">
                            <div id="bannerDiv" className="col-lg-10 col-sm-12">
                                <LoginCarousel />
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-sm-12 col-xs-12 keep-in">
                        <form
                            name="loginForm"
                            id="loginForm"
                            method="POST"
                            autoComplete="off"
                            onSubmit={handleLogin}
                        >
                            <div className="login">
                                <p className="title">Log in</p>
                                <span
                                    id="failed_msg_span"
                                    className="mag-left-30px d-none bg-danger"
                                >
                                    <small>
                                        <b id="failed_msg"></b>
                                    </small>
                                </span>
                                <section id="loginSection" className="">
                                    <input
                                        ref={userRef}
                                        type="text"
                                        id="UserID"
                                        name="UserID"
                                        placeholder="User ID"
                                        autoFocus
                                        className="height-35px font-size-13px"
                                        value={uid}
                                        onChange={(e) => setUserId(e.target.value)}
                                    />
                                    <i className="fa fa-user"></i>
                                    <span
                                        id="rfv_userid"
                                        className="mag-left-30px d-none bg-danger"
                                    >
                                        <small>
                                            <b>* User ID is required</b>
                                        </small>
                                    </span>
                                </section>
                                <section id="passwordSection" className="">
                                    <div style={{ position: 'relative' }}>
                                        <input
                                            type={showPassword ? 'text' : 'password'}
                                            id="Password"
                                            name="Password"
                                            placeholder="Password"
                                            className="height-35px font-size-13px"
                                            maxLength={99}
                                            value={pwd}
                                            onChange={(e) => setUserPwd(e.target.value)}
                                        />
                                        <i className="fa fa-key"></i>
                                        <span
                                            onClick={togglePassword}
                                            style={{
                                                position: 'absolute',
                                                right: '35px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                cursor: 'pointer',
                                                userSelect: 'none'
                                            }}
                                        >
                                            {showPassword ?  
                                                <div id="div_pw_eye" className="fa showPasswordButtonLogin fa-eye" aria-hidden="true"></div> 
                                                : 
                                                <div id="div_pw_eye" className="fa showPasswordButtonLogin fa-eye-slash" aria-hidden="true"></div>
                                            }
                                        </span>
                                    </div>
                                 
                                    <span
                                        id="rfv_password"
                                        className="mag-left-30px d-none bg-danger"
                                    >
                                        <small>
                                            <b>* Password is required</b>
                                        </small>
                                    </span>
                                </section>
                                <section id="securityCodeSection" className="">
                                    <input
                                        type="text"
                                        id="SecurityCode"
                                        name="SecurityCode"
                                        placeholder="Security Code"
                                        className="height-35px font-size-13px"
                                        
                                        value={securitycode}
                                        onChange={(e) => {
                                            const numericValue = e.target.value.replace(/\D/g, ''); // remove non-digits
                                            setSecuritycode(numericValue);
                                        }}
                                    />
                                    <i className="fa fa-shield"></i>
                                    <span
                                        id="rfv_securitycode"
                                        className="mag-left-30px d-none bg-danger"
                                    >
                                        <small>
                                            <b>* Security Code is required</b>
                                        </small>
                                    </span>
                                </section>
                                <section id="loginTypeSection" className="">
                                    <table className="wid-96p">
                                            <td>
                                                <table className="wid-40p">
                                                    <tr className="height-25px">
                                                    </tr>
                                                </table>
                                            </td>
                                    </table>
                                </section>
                                <section id="forgetPwdSection" className="" style={{fontSize: '13px', marginLeft:'30px',}}>
                                    <div style={{marginBottom: '10px'}}>
                                        <a style={{cursor: 'pointer', textDecoration: 'underline',color:"black"}} href={Config.mfaUserGuideUrl} target="_blank" >
                                            How to generate a security code &gt;
                                        </a>
                                    </div>
                                    <h6 style={{fontSize: '13px'}}>
                                        By logging in, you accept the Terms of use and agree to be bound by them.
                                    </h6>
                                    <div>
                                        <u 
                                        style={{
                                            cursor: 'pointer',
                                        }}
                                        onClick={() =>
                                        {
                                            navigate('/forget-password')
                                        }
                                        }>Forgot Password / Unblock Account</u>
                                    </div>
                                   <u 
                                    style={{
                                        cursor: 'pointer',
                                    }}
                                    onClick={() =>
                                    {
                                        navigate('/forget-userid')
                                    }
                                    }>Forgot User ID?</u>
                                </section>
                                <section id="loginButtonSection">
                                    <p id="p_login">
                                        <button
                                            type="submit"
                                            id="btn_login"
                                            name="btn_login"
                                            style={{fontSize: '14px',}}
                                        >
                                            <i className="fa fa-lock"></i>
                                            &nbsp;Log in
                                        </button>
                                    </p>
                                    <p >
                                
                                        <button
                                        onClick={() => navigate('/first-time-login')}
                                        type="button"
                                        id="btn_first_time_login"
                                        name="btn_first_time_login"
                                        style={{fontSize: '14px',}}
                                    >
                                        <i className="fa fa-arrow-right"></i>
                                        &nbsp;First Time Login
                                    </button>
                                    </p>
                            
                                </section>
                    
                            </div>
                            <div id="webecos_hidden_div">
                                <input type="hidden" id="uId" name="uId" />
                                <input
                                    type="hidden"
                                    id="exchng"
                                    name="exchng"
                                    value="SGX"
                                />
                                <input type="hidden" id="symbol" name="symbol" />
                                <input
                                    type="hidden"
                                    id="infoMode"
                                    name="infoMode"
                                    value="LV"
                                />
                                <input type="hidden" id="id" name="id" value="RS" />
                                <input
                                    type="hidden"
                                    id="idx"
                                    name="idx"
                                    value="AN"
                                />
                            </div>
                            <div id="iress_hidden_div">
                                <input
                                    type="hidden"
                                    id="furl"
                                    name="furl"
                                    value=""
                                />
                                <input
                                    type="hidden"
                                    id="title"
                                    name="title"
                                    value="Foreign Market by UOB Kay Hian"
                                />
                            </div>
                        </form>
                    </div>
                </div>
            </section>
            {displayForgetPassword && (
                <ForgetPassword
                    setModelOpen={(status: any) =>
                        setDisplayForgetPassword(status)
                    }
                />
            )}   
            <AdsModal opened={false} />
        </>
    );
};

const UtradeLogin = () => {
    return (
        <div className="utradeBody">
            <TopHeader />
            {topLogoNav()}
            <div className="container" style={{width:'1140px'}}>
                <div className="row-fluid">
                    <div id="page-wrapper">
                        <div  style={{paddingTop: '80px', paddingBottom: '80px'}}>{LoginBody()}</div>                        
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default UtradeLogin;
